import { useRef } from "react"
import { useMotionValueEvent, useTransform } from "framer-motion"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import { cssVars } from "components/nav-v2/Wrapper"
import { setProperty } from "./utils"
import Categories from "./Categories"
import Filters, { SGFiltersList } from "./Filters"
import { useSG } from "./context"
import getMediaQuery from "css/breakpoints"

const Main = styled.div`
  position: sticky;
  --sg-menu-top: calc(var(${cssVars.main.safe}) * var(${cssVars.main.bar.pinned}));
  top: var(--sg-menu-top);
  z-index: 1;
  grid-row: 1/-1;
  grid-column: 1/-1;
  width: 100%;
  display: grid;
  grid-template-columns: 20px 1fr min-content;
  ${getMediaQuery("m")} {
    grid-template-columns: 100px 1fr 100px;
  }
`

const Overlay = styled.div`
  position: absolute;
  grid-column: 1/-1;
  grid-row: 1/-1;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
`

export default function SGMenu({ categories, filters, avail_priority, mayReset, Y, mask }) {
  const console = useConsole()

  const with_filters = filters?.item.length

  const { T, filtering } = useSG()

  const rfmain = useRef(null)

  const pinned = useTransform([Y, T], ([y, t]) => +(y >= t))

  function onPinned(v) {
    setProperty(rfmain.current, "--sg-filters-pinned", v)
  }
  useMotionValueEvent(pinned, "change", onPinned)

  function onFiltering(v) {
    rfmain.current.classList[v ? "add" : "remove"]("sg-filters-active")
  }
  useMotionValueEvent(filtering, "change", onFiltering)

  return (
    <Main ref={rfmain} className={with_filters ? "sg-menu-filters" : null} aria-label={categories.title}>
      <Overlay />
      {categories ? (
        <>
          <Categories {...categories} priority={avail_priority} mayReset={mayReset} mask={mask} />
          {with_filters ? <Filters {...filters} /> : null}
          {with_filters ? <SGFiltersList {...filters} filtering={filtering} priority={avail_priority} mayReset={mayReset} mask={mask} /> : null}
        </>
      ) : null}
    </Main>
  )
}
